import React, { useState, useEffect, Context, Suspense } from 'react';
import { Routes, Route, redirect } from 'react-router-dom';
import HomePage from './components/HomePage';
import SignInUp from './components/SignInUp';
import Pricing from './components/Pricing';
import Unsubscribe from './components/Unsubscribe';
import Logout from './components/Logout';
import About from './components/About';
import { ResetPasswordForm, RequestResetForm } from './components/ResetPassword';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';
import LoadingLogo from './components/LoadingLogo';

import NotFound from './components/NotFound';
import { GlobalContext, GlobalContextType } from './context/GlobalContext';
import './style/main.less';

import { Session, User } from '@supabase/supabase-js';

import { getSession } from './supabase/supabase';

// Lazy load heavy components
const Subscribe = React.lazy(() => import('./components/Subscribe'));
const Dashboard = React.lazy(() => import('./components/Dashboard'));
const ImageViewer = React.lazy(() => import('./components/ImageViewer'));

function App() {
    const [session, setSession] = useState<Session | null>(null);
    const [user, setUser] = useState<User | null>(null);

    const initSession = async () => {
        const lSession = localStorage.getItem('session');
        if (lSession) {
            const session = JSON.parse(lSession) as Session;
            // console.log('from local storage', session);
            setSession(session);
        } else {
            const session = await getSession();
            // console.log('from supabase', session);
            setSession(session);
            localStorage.setItem('session', JSON.stringify(session));
        }
    };

    useEffect(() => {
        initSession();
    }, []);

    const global: GlobalContextType = {
        session: session,
        user: user,
        setSession: setSession,
        setUser: setUser
    };

    return (
        <GlobalContext.Provider value={global}>
            <Suspense fallback={<LoadingLogo />}>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/login" element={<SignInUp />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/s/:id" element={<Subscribe />} />
                    <Route path="/unsubscribe" element={<Unsubscribe />} />
                    <Route path="/images/:token" element={<ImageViewer />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/forgot-password" element={<RequestResetForm />} />
                    <Route path="/reset-password" element={<ResetPasswordForm />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsOfUse />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        </GlobalContext.Provider>
    );
}

export default App;
